// 메인배너 이미지 데이터

export const bannerData = {
  main: [
    {
      filename: "main_1",
      alt: "main_1",
      text: "Penhaligons Trade Routes",
    },
    {
      filename: "main_2",
      alt: "main_2",
      text: "Penhaligons ALULA",
    },
    {
      filename: "main_3",
      alt: "main_3",
      text: "Potions & Remedies",
    },
    {
      filename: "main_4",
      alt: "main_4",
      text: "Penhaligons Portraits",
    },
    {
      filename: "main_5",
      alt: "main_5",
      text: "Customer's Favorite",
    },
  ],

  shop: [
    {
      filename: "shop_1",
      alt: "shop_1",
      text: "Shop Your Favorites",
    },
    {
      filename: "shop_2",
      alt: "shop_2",
      text: "Shop Quality Products",
    },
    {
      filename: "shop_3",
      alt: "shop_3",
      text: "Shop Quality Products",
    },
  ],
  collection: [
    {
      filename: "collection_1",
      alt: "collection_1",
      text: "Penhaligons Endymion",
    },
    {
      filename: "collection_2",
      alt: "collection_2",
      text: "Penhaligons Solaris",
    },
    {
      filename: "collection_3",
      alt: "collection_3",
      text: "Penhaligons Halfeti",
    },
  ],
  ourstory: [
    {
      filename: "ourstory_1",
      alt: "ourstory_1",
      text: "Stories from Us",
    },
    {
      filename: "ourstory_2",
      alt: "ourstory_2",
      text: "Inside Our World",
    },
    {
      filename: "ourstory_3",
      alt: "ourstory_3",
      text: "Inside Our World",
    },
  ],
  board: [
    {
      filename: "board_1",
      alt: "board_1",
      text: "Stories from Us",
    },
    {
      filename: "board_2",
      alt: "board_2",
      text: "Inside Our World",
    },
    {
      filename: "board_3",
      alt: "board_3",
      text: "Inside Our World",
    },
  ],
  penhaligons: [
    {
      filename: "penhaligons_1",
      alt: "Penhaligons_1",
      text: "Meet Penhaligons",
    },
    {
      filename: "penhaligons_2",
      alt: "Penhaligons_2",
      text: "About Us",
    },
    {
      filename: "penhaligons_3",
      alt: "Penhaligons_3",
      text: "About Us",
    },
  ],
  search: [
    {
      filename: "search_1",
      alt: "search_1",
      text: "Search here!",
    },
    {
      filename: "search_2",
      alt: "search_2",
      text: "Search here!",
    },
    {
      filename: "search_3",
      alt: "search_3",
      text: "Search here!",
    },
  ],
  login: [
    {
      filename: "login_1",
      alt: "login_1",
      text: "Welcome back!",
    },
    {
      filename: "login_2",
      alt: "login_2",
      text: "Welcome back!",
    },
    {
      filename: "login_3",
      alt: "login_3",
      text: "Welcome back!",
    },
  ],
  member: [
    {
      filename: "member_1",
      alt: "member_1",
      text: "Welcome Our World",
    },
    {
      filename: "member_2",
      alt: "member_2",
      text: "Welcome Our World",
    },
    {
      filename: "member_3",
      alt: "member_3",
      text: "Welcome Our World",
    },
  ],
};
